import React from "react";
import PropTypes from "prop-types";
const CommonTable = (props) => {
    return (
        <table id={props.id} className="table menu-tableAlignment-width">
            <thead className="table-header-etp">
                <tr>
                    {props.columns.map((item,index) => {
                        return <th key={index}>{item}</th>
                    })}
                </tr>
            </thead>
        </table>
    )
}
CommonTable.propTypes = {
    id: PropTypes.any,
    columns: PropTypes.any
}

export default CommonTable